import { AgeDistributionSection } from '../components/AgeDistributionSection';
import { AnalyticsStatsGrid } from '../components/AnalyticsStatsGrid';
import { CampaignTrendsSection } from '../components/CampaignTrendsSection';
import { TotalAnalyticsHeader } from '../components/TotalAnalyticsHeader';
import { useTotalAnalyticsPage } from '../hooks/useTotalAnalyticsPage';

export function TotalAnalyticsPage() {
  const {
    cards,
    trendsData,
    ageDistribution,
    ageTotal,
    dateRangeLabel,
    periodSummary,
    isLoading,
  } = useTotalAnalyticsPage();

  return (
    <div className="flex flex-col gap-5 p-1 sm:p-0">
      <TotalAnalyticsHeader />
      <AnalyticsStatsGrid cards={cards} />
      <CampaignTrendsSection
        dateRangeLabel={dateRangeLabel}
        periodSummary={periodSummary}
        trendsData={trendsData}
        isLoading={isLoading}
      />
      <AgeDistributionSection items={ageDistribution} total={ageTotal} />
    </div>
  );
}
